export default "__VITE_ASSET__BlljC3dO__"